$(document).ready(function() {
  // var type =  $('#part_unit_type').val()
  //   $.ajax({
  //     type: 'GET',
  //     url: `/parts/fetch_units`,
  //     data: {
  //       type: type
  //     }

  //   })

  $(document).on('change', "#part_unit_type", function (e) {
    var type = e.target.value
    $.ajax({
      type: 'GET',
      url: `/parts/fetch_units`,
      data: {
        type: type
      }

    })
  });
})